//export const HOST = 'https://apimv.ticservice.org:17100/';
export const HOST = process.env.REACT_APP_API_URL;
export const VERSION = 'api/v1/';

const APP_URL = {
    // AUTH
    LOGIN: `${HOST}${VERSION}auth/login/`,

    //SALES
    SEARCHSALESPHONE: `${HOST}${VERSION}admin/sales/searchSalesPhone`,
    CREATESALES: `${HOST}${VERSION}admin/sales/createSales`,
    CREATEDOCSADD: `${HOST}${VERSION}admin/sales/createDocsAdd`,
    DRAFTSALES: `${HOST}${VERSION}admin/sales/draftSales`,
    UPDATESALES: `${HOST}${VERSION}admin/sales/updateSales`,
    TOTALSALES: `${HOST}${VERSION}admin/sales/totalSales`,
    TOTALSALESSTATUS: `${HOST}${VERSION}admin/sales/totalSalesStatus`,
    TOTALSALESAGENTS: `${HOST}${VERSION}admin/sales/totalSalesAgents`,
    TOTALSALESMONTH: `${HOST}${VERSION}admin/sales/totalSalesMonth`,
    TOTALSALESAGENTSPLANDAY: `${HOST}${VERSION}admin/sales/totalSalesAgentsPlanDay`,
    TOTALSALESAGENTSPLANMONTH: `${HOST}${VERSION}admin/sales/totalSalesAgentsPlanMonth`,
    TOTALSALESFORPLAN: `${HOST}${VERSION}admin/sales/totalSalesForPlan`,
    TOTALSALESMONTHLASTVSCURRENT: `${HOST}${VERSION}admin/sales/totalSalesMonthLastVsCurrent`,
    TOTALSALESMONTHCOMPANY: `${HOST}${VERSION}admin/sales/totalSalesMonthCompany`,
    LISTYEARS: `${HOST}${VERSION}admin/sales/listYears`,
    LISTGOALS: `${HOST}${VERSION}admin/sales/listGoals`,
    CREATEGOALS: `${HOST}${VERSION}admin/sales/createGoals`,
    EDITGOALS: `${HOST}${VERSION}admin/sales/editGoals`,
    CREATEGOALPREMIUMYEAR: `${HOST}${VERSION}admin/sales/createGoalPremiumYear`,
    SEARCHGOALPREMIUMYEAR: `${HOST}${VERSION}admin/sales/searchGoalPremiumYear`,
    SEARCHSALESPRE: `${HOST}${VERSION}admin/sales/searchsalespre`,
    UPDATESTATUSSALES: `${HOST}${VERSION}admin/sales/updateStatusSales`,
    FORWARDEMAILSALE: `${HOST}${VERSION}admin/sales/forwardEmailSale`,
    SEARCHSALESAGENTS: `${HOST}${VERSION}admin/sales/searchsalesagents`,
    SEARCHSALESPROCESSOR: `${HOST}${VERSION}admin/sales/searchsalesprocessor`,
    TOTALSALESAGENTSUSER: `${HOST}${VERSION}admin/sales/totalSalesAgentsUser`,
    TOTALSALESMONTHUSER: `${HOST}${VERSION}admin/sales/totalSalesMonthUser`,
    REPORTSFILTER: `${HOST}${VERSION}admin/sales/reportsFilters`,
    
    
    
    //SALES INDICATORS
    TOTALSALESLASTDAYS: `${HOST}${VERSION}admin/sales/totalSalesLastDays`,

    TOTALSALESCOMPANYDAY: `${HOST}${VERSION}admin/obamacare/totalSalesCompanyDay`,
    TOTALSALESCOMPANYMONTH: `${HOST}${VERSION}admin/obamacare/totalSalesCompanyMonth`,
    TOTALSALESCOMPANYYEAR: `${HOST}${VERSION}admin/obamacare/totalSalesCompanyYear`,
    

    // ADMIN - APPOINTMENT
    SEARCH_PATIENTS_APPOINTMENTS: `${HOST}${VERSION}admin/appointment/searchPatient`,
    UPLOAD_EVIDENCES: `${HOST}${VERSION}admin/appointment/uploadFiles`,
    CREATE_APPOINTMENT: `${HOST}${VERSION}admin/appointment/create`,
    LIST_APPOINTMENTS: `${HOST}${VERSION}admin/appointment/list`,
    CHANGE_STATUS_APPOINTMENT: `${HOST}${VERSION}admin/appointment/updateStatus`,
    LIST_FILE_APPOINTMENTS: `${HOST}${VERSION}admin/appointment/listFiles`,
    LIST_APP_STATUS_USER: `${HOST}${VERSION}admin/appointment/listAppStatusUser`,
    COUNT_APPOINTMENT_TOTAL_DAY_MONTH: `${HOST}${VERSION}admin/appointment/CountAppointmentTotalDayMonth`,
    COUNT_APP_STATUS: `${HOST}${VERSION}admin/appointment/countAppStatusUser`,
    LIST_TRACKER: `${HOST}${VERSION}admin/appointment/listTracker`,

    // ADMIN - APPOINTMENT - REFFERED
    CREATE_REFFERED: `${HOST}${VERSION}admin/appointment/createReffered`,
    LIST_REFFERED_ALL: `${HOST}${VERSION}admin/appointment/listRefferedAll`,
    LIST_REFFERED_AGENT: `${HOST}${VERSION}admin/appointment/listReffered`,
    UPDATE_REFFERED: `${HOST}${VERSION}admin/appointment/updateReffered`,
    CREATE_TRACKER: `${HOST}${VERSION}admin/appointment/createTracker`,
    EDIT_DATA_USER: `${HOST}${VERSION}admin/appointment/edit`,
    
    // ADMIN - PARAMETER
    LOAD_INSURANCE: `${HOST}${VERSION}admin/parameter/list`,

    // CREATE FORM OBAMA CARE
    CREATE_FORM_OBAMA_CARE: `${HOST}${VERSION}admin/obamacare/create`,

    // PARAMETER
    LOAD_PARAMETER: `${HOST}${VERSION}admin/parameter/list/`,
    
    // LIST STATUS
    LIST_STATUS: `${HOST}${VERSION}admin/obamacare/listStatusTracker`,
    LIST_STATUS_SUPERVISOR: `${HOST}${VERSION}admin/obamacare/listStatusTrackersupervisor`,

    // SEARCH PATIENTS
    SEARCH_PATIENTS: `${HOST}${VERSION}admin/patients/search`,

    // Status Follow-up
    LIST_TRACKING: `${HOST}${VERSION}admin/obamacare/listTracker`,
    CREATE_TRACKING: `${HOST}${VERSION}admin/obamacare/createTracker`,
    UPDATE_TRACKING: `${HOST}${VERSION}admin/obamacare/updateTracker`,
    UPDATE_FORMOBAMACARE: `${HOST}${VERSION}admin/obamacare/editform`,

    // Upload
    UPLOADEXCELFILE: `${HOST}${VERSION}admin/upload/uploadexcel`,
    UPLOADEXCELMASIVE: `${HOST}${VERSION}admin/upload/uploadexcelMasive`,
    UPLOADBLACKLISTEXCELFILE: `${HOST}${VERSION}admin/upload/uploadBlackListexcel`,
    LISTBLACKLIST: `${HOST}${VERSION}admin/upload/listBlackList`,
    LISTPHONEAGENTALL: `${HOST}${VERSION}admin/upload/listPhoneAgentAll`,
    LISTAGENTALL: `${HOST}${VERSION}admin/upload/listAgentAll`,
    LISTALLUSER: `${HOST}${VERSION}admin/upload/listAllUser`,
    UPDATESTATUS: `${HOST}${VERSION}admin/upload/updateStatus`,

    LISTAGENTALLFILTER: `${HOST}${VERSION}admin/upload/listAgentAllFilter`,
    LISTAGENTFILTER: `${HOST}${VERSION}admin/upload/listAgentFilter`,
    LISTAGENTFILTERSTATUS: `${HOST}${VERSION}admin/upload/listAgentFilterStatus`,

    // USERS
    LISTUSERS: `${HOST}${VERSION}admin/users/list`,
    CREATEUSERS: `${HOST}${VERSION}admin/users/create`,
    UPDATEUSERS: `${HOST}${VERSION}admin/users/update`,
    UPDATESTATUSUSERS: `${HOST}${VERSION}admin/users/updateStatus`,
    UPDATEPASSUSERS: `${HOST}${VERSION}admin/users/updatePass`,
    LISTAGENT: `${HOST}${VERSION}admin/users/listAgent`,
    LISTAGENTON: `${HOST}${VERSION}admin/users/listAgentON`,
    REPORTLOGIN: `${HOST}${VERSION}admin/users/reportLogin`,

    // CRUD AGENT
    CREATEASSIGNEDAGENT: `${HOST}${VERSION}admin/assignedagent/create`,
    UPDATEASSIGNEDAGENT: `${HOST}${VERSION}admin/assignedagent/update`,
    UPDATESTATUSAGENT: `${HOST}${VERSION}admin/assignedagent/updatestatus`,
    LISTASSIGNEDAGENT: `${HOST}${VERSION}admin/assignedagent/list`,
    
    // CREATE LIST PHONE CARE CROSS
    CREATELISTCARECROSS: `${HOST}${VERSION}admin/carecross/createlistphone`,
    LISTPHONECARECROSS: `${HOST}${VERSION}admin/carecross/listphone`,
    
    // REPORTS STATUS PHONE 
    REPORTSTATUSPHONE: `${HOST}${VERSION}admin/obamacare/reports`,
    REPORTSTATUSPHONENOANSWERAGENT: `${HOST}${VERSION}admin/obamacare/reportnumbernoansweragent`,
    DELETEAPPOINTMENT: `${HOST}${VERSION}admin/obamacare/deleteAppointment`,
    
    // UPDATE STATUS PHONE AGENT
    UPDATESTATUSPHONEAGENT: `${HOST}${VERSION}admin/obamacare/updatestatusphoneagent`,

    // APPOINTMENT SALES
    //CREATESALES: `${HOST}${VERSION}admin/obamacare/createsales`,
    CREATESALESPENDING: `${HOST}${VERSION}admin/obamacare/createsalespending`,
    CREATESALESDRAFTAGENT: `${HOST}${VERSION}admin/obamacare/createsalesDraftAgent`,
    UPDATESALESPROCESS: `${HOST}${VERSION}admin/obamacare/updatesalesProcess`,
    UPDATESALESDATA: `${HOST}${VERSION}admin/obamacare/updatesalesData`,
    UPDATESALESDATARECOVERY: `${HOST}${VERSION}admin/obamacare/updatesalesDataRecovery`,
    UPDATESALESFILE: `${HOST}${VERSION}admin/obamacare/updateSalesFile`,
    UPDATESALESFILEADD: `${HOST}${VERSION}admin/obamacare/updateSalesFileAdd`,
    UPDATESALESVERIFYBACKOFFICE: `${HOST}${VERSION}admin/obamacare/updateSalesVerifyBackOffice`,
    UPDATEUPLOADSALESDOCUMENT: `${HOST}${VERSION}admin/obamacare/updateUploadSalesDocument`,
    UPDATESTATUSFINISH: `${HOST}${VERSION}admin/obamacare/updateStatusFinish`,
    UPDATESTATUSFINISHNPN: `${HOST}${VERSION}admin/obamacare/updateStatusFinishNPN`,

    SEARCHSALESDEPENDENT: `${HOST}${VERSION}admin/obamacare/searchsalesdepent`,
    SEARCHSALESPLAN: `${HOST}${VERSION}admin/obamacare/searchsalesplan`,
    SEARCHSALESBENEFICIARIES: `${HOST}${VERSION}admin/obamacare/searchsalesbeneficiaries`,
    SEARCHUPLOADSALESDOCUMENT: `${HOST}${VERSION}admin/obamacare/searchuploadsalesdocument`,
    DELETEUPLOADSALES: `${HOST}${VERSION}admin/obamacare/deleteuploadsales`,
    DELETEUPLOADADDSALES: `${HOST}${VERSION}admin/obamacare/deleteuploadAddsales`,
    
    SEARCHSALESPROCESSORBO: `${HOST}${VERSION}admin/obamacare/searchsalesprocessorBO`,
    SEARCHSALESPROCESSORRECOVERY: `${HOST}${VERSION}admin/obamacare/searchsalesprocessorRecovery`,
    SEARCHSALESOBSERVATION: `${HOST}${VERSION}admin/obamacare/searchsalesobservation`,
    

 
    SEARCHNOTEPAD: `${HOST}${VERSION}admin/obamacare/searchNotePad`,
    SAVENOTEPAD: `${HOST}${VERSION}admin/obamacare/saveNotePad`,
    SAVENOTECOLUMNS: `${HOST}${VERSION}admin/obamacare/saveNotecolumns`,
    SEARCHNOTECOLUMNS: `${HOST}${VERSION}admin/obamacare/searchNoteColumns`,

    LISTSALESSUPERVISOR: `${HOST}${VERSION}admin/obamacare/listSalesSupervisor`,
    LISTSALESBACKOFFICE: `${HOST}${VERSION}admin/obamacare/listSalesBackOffice`,

    EXPORTFILESXLXS: `${HOST}${VERSION}admin/obamacare/exportFileXLXS`,
    EXPORTFILESXLXSPROCESSOR: `${HOST}${VERSION}admin/obamacare/exportFileXLXSProcessor`,
    EXPORTFILESXLXSQUALITY: `${HOST}${VERSION}admin/obamacare/exportFileXLXSQuality`,
    DELETEFILESXLXS: `${HOST}${VERSION}admin/obamacare/deleteFileXLXS`,
    SEARCHSALESQUALITY: `${HOST}${VERSION}admin/obamacare/searchsalesquality`,
    SEARCHVERIFYMONTH: `${HOST}${VERSION}admin/obamacare/searchVerifyMonth`,
    INSERTVERIFYMONTH: `${HOST}${VERSION}admin/obamacare/insertVerifyMonth`,
    
    LISTPRENEWAPPOINTMENTSALES: `${HOST}${VERSION}admin/obamacare/listprenewappointmentsales`,
    LISTAPPOINTMENTSALESDATE: `${HOST}${VERSION}admin/obamacare/listappointmentsalesdate`,
    SEARCHAPPOINTMENTSALES: `${HOST}${VERSION}admin/obamacare/searchappointmentsales`,
    SEACRHSALES: `${HOST}${VERSION}admin/obamacare/searchsales`,
    UPDATEFORMSALES: `${HOST}${VERSION}admin/obamacare/updateformsales`,
    DELETESALES: `${HOST}${VERSION}admin/obamacare/deletesales`,

    // FORM SUPLEMENTAL
    UPLOADFORMSUPLEMENTAL: `${HOST}${VERSION}admin/obamacare/uploadformsuplemental`,
    LISTFORMSUPLEMENTAL: `${HOST}${VERSION}admin/obamacare/listformsuplemental`,
    UPDATEFORMSUPLEMENTAL: `${HOST}${VERSION}admin/obamacare/updateformsuplemental`,
    DELETESUPLEMENTAL: `${HOST}${VERSION}admin/obamacare/deletesuplemental`,
    
    // AGENCY
    LISTAGENCY: `${HOST}${VERSION}admin/agency/listagency`,
    CREATEAGENCY: `${HOST}${VERSION}admin/agency/createagency`,
    UPDATEAGENCY: `${HOST}${VERSION}admin/agency/updateagency`,

    EXPORTDATAEXCELFILTER: `${HOST}${VERSION}admin/obamacare/exportDataExcelFilters`,
    LISTSALESBACKOFFICEFILTER: `${HOST}${VERSION}admin/obamacare/listSalesBackOfficeFilter`,

    TRANSFERSALES: `${HOST}${VERSION}admin/obamacare/transferSales`,

    //BTN
    SEARCHSALESBTN: `${HOST}${VERSION}admin/sales/searchSalesBTN`,
    CREATESALES_2: `${HOST}${VERSION}admin/sales/createSales_2`,
    UPDATESALES_2: `${HOST}${VERSION}admin/sales/updateSales_2`,
    LISTSALES_2: `${HOST}${VERSION}admin/sales/listSales_2`,
    LISTSALES_2_OBSERVATION: `${HOST}${VERSION}admin/sales/listSales_2_observation`,
    LISTSALES_2_CONTACTS: `${HOST}${VERSION}admin/sales/listSales_2_contact`,
    ADDSALE_2_OBSERVATION: `${HOST}${VERSION}admin/sales/addSale_2_Observation`,
    LISTFILTERSALES_2: `${HOST}${VERSION}admin/sales/listFilterSales_2`,
    SENDEMAILSALES_2: `${HOST}${VERSION}admin/sales/sendEmailSales_2`,
    SENDPAY: `${HOST}${VERSION}admin/sales/sendPay`,
    DOWNLOADPDF: `${HOST}${VERSION}admin/sales/downloadPDF`,
    LISTODOCUMENTSALES_2: `${HOST}${VERSION}admin/sales/listDocumentSales_2`,
    CREATESALES_2_UPLOAD_DOCUMENT: `${HOST}${VERSION}admin/sales/createSales_2_upload_document`,
    DELETEUPLOADSALES_2: `${HOST}${VERSION}admin/sales/deleteuploadsales_2`,

    SAVEINFOQR: `${HOST}${VERSION}admin/email/saveInfoQR/`,
    SENDEMAILCONTACTUS: `${HOST}${VERSION}admin/email/sendEmailContactus`,

    //Other
    CREATESALES_3: `${HOST}${VERSION}admin/sales/createSales_3`,
    LISTSALES_3_OBSERVATION: `${HOST}${VERSION}admin/sales/listSales_3_observation`,
    LISTFILTERSALES_3: `${HOST}${VERSION}admin/sales/listFilterSales_3`,
    UPDATESALES_3: `${HOST}${VERSION}admin/sales/updateSales_3`,
    ADDSALE_3_OBSERVATION: `${HOST}${VERSION}admin/sales/addSale_3_Observation`,

    //Archivos
    DESCARGARARCHIVO: `${HOST}${VERSION}/admin/upload/descargarArchivo/`,

    //Emails
    SAVEEMAIL: `${HOST}${VERSION}admin/email/saveEmail`,
    LISTEMAIL: `${HOST}${VERSION}admin/email/listEmail`,
    LISTFILTEREMAIL: `${HOST}${VERSION}admin/email/listFilterEmail`,
    LISTEMAILREPLY: `${HOST}${VERSION}admin/email/listEmailReply`,
    EMAILUNREAD: `${HOST}${VERSION}admin/email/emailUnread`,
    SEARCHTEMPLATEEMAIL: `${HOST}${VERSION}admin/email/searchTemplateEmail`,
    UPLOADFILEEMAILS: `${HOST}${VERSION}admin/email/uploadFilesEmails`,

    LISTNOTIFICATION: `${HOST}${VERSION}admin/users/listNotification`,
    LISTNOTIFICATIONLIMIT: `${HOST}${VERSION}admin/users/listNotificationLimit`,
    UPDATEVIEWNOTIFICATION: `${HOST}${VERSION}admin/users/updateViewNotification`,

    UPDATESALESAGENTCLOSED: `${HOST}${VERSION}admin/sales/updateSalesAgentClosed`,
    UPDATESALESSTATUS: `${HOST}${VERSION}admin/sales/updateSalesStatusAR`,
    UPDATEUPLOADNUMBER: `${HOST}${VERSION}admin/users/updateUploadNumber/`,
    DELETENUMBERUPLOADAGENTS: `${HOST}${VERSION}admin/users/deleteNumberUploadAgents`,
    LISTTOTALSTATUSUPLOADAGENT: `${HOST}${VERSION}admin/users/listTotalStatusUploadAgent`,
    EXPORTUPLOADAGENTS: `${HOST}${VERSION}admin/users/exportUploadAgents`,
    SAVENAMEDB: `${HOST}${VERSION}admin/upload/saveNameDB`,
    LISTNAMEDB: `${HOST}${VERSION}admin/upload/listNameDB`,
}

export default APP_URL
